import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { SystemMessage, SystemMessageAudience, SystemMessagesService } from 'src/app/services/system-messages.service';

@Component({
  selector: 'app-system-message-banner',
  templateUrl: './system-message-banner.component.html',
  styleUrls: ['./system-message-banner.component.scss'],
  standalone: false
})
export class SystemMessageBannerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() audience?: SystemMessageAudience;
  @Input() authenticated = false;

  systemMessage: SystemMessage | null = null;
  private readonly subscriptions = new Subscription();

  constructor(private systemMessages: SystemMessagesService, private router: Router) {}

  ngOnInit(): void {
    this.loadMessage();
    this.subscriptions.add(
      this.systemMessages.liveMessageChanged$.subscribe(() => this.loadMessage())
    );
    if (!this.authenticated) {
      this.subscriptions.add(this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => this.loadMessage()));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['audience']?.firstChange || !changes['authenticated']?.firstChange) {
      this.loadMessage();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private loadMessage(): void {
    const request = this.authenticated
      ? this.systemMessages.getAuthenticatedMessage()
      : this.loginAudience
        ? this.systemMessages.getLoginMessage(this.loginAudience)
        : null;

    if (!request) {
      this.systemMessage = null;
      return;
    }

    request.subscribe(message => this.systemMessage = message);
  }

  private get loginAudience(): SystemMessageAudience | undefined {
    if (this.audience) return this.audience;
    if (this.router.url.startsWith('/auth/admin-signin')) return 'admin';
    if (this.router.url.startsWith('/auth/specialist-signin')) return 'specialist';
    if (this.router.url.startsWith('/auth/pcv-signin')) return 'hospital';
    return undefined;
  }
}
